// Keep referral functionality in the codebase while hiding its page and navigation.
export const referralsVisible = false;
